import { Component, OnInit, OnDestroy } from '@angular/core';
import { ApiService } from './../../shared/services/api.service';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';

import * as moment from 'moment';
import { DataUtils } from './../../shared/utils/data-utils';
import { BookingOffer } from './../../models/bookings/bookings.model';

@Component({
  selector: 'swb-bookings-overview',
  templateUrl: './bookings-overview.component.html'
})
export class BookingsOverviewComponent implements OnInit, OnDestroy {

  private _id: number;
  private _date = moment().utc();

  public get id(): number {
    return this._id;
  }

  public isInitialized = false;

  public booking_offer: BookingOffer;

  public get date(): Date {
    return this._date.toDate();
  }

  public loading = true;

  public days: Array<moment.Moment>;
  public preDays: Array<number>;
  public postDays: Array<number>;

  public dayHeaders: Array<string> = moment.weekdaysShort(true);

  constructor(
    private _apiService: ApiService,
    private _route: ActivatedRoute,
    private _router: Router
  ) { }

  public ngOnInit(): void {
    this.init();
    this._router.events.subscribe(e => {
      if (e instanceof NavigationEnd) {
        this.init();
      }
    });
  }
  public init() {
    if (typeof this._route.snapshot.params['id'] !== 'undefined') {
      this._id = this._route.snapshot.params['id'];
      this._getEntity();
    }
  }

  private _getEntity() {
    this.loading = true;
    this._apiService.get(
      'booking-offers' + '/' + this._id + '/' + this._date.clone().month() + '/' + this._date.clone().year()
    )
      .subscribe(
        (response: any) => {
          const startDay = this._date.clone().startOf('month').day();

          const postFiller = new Array(7 - this._date.clone().endOf('month').day()).fill(null).map((x, i) => i + 1);
          this.preDays = startDay > 0 ? new Array(startDay - 1).fill(null).map((x, i) => i + 1) : [];

          this.postDays = postFiller.length >= 7 ? [] : postFiller;
          this.days = new Array(this._date.clone().daysInMonth()).fill(null).map((x, i) =>
            this._date.clone().startOf('month').add(i, 'days'));
          this.booking_offer = { ...response }.data;

          this.loading = false;

        },
        (error) => console.error(error)
      );
  }

  public ngOnDestroy(): void {
    // TODO: do something
  }

  public getTitle(titleObject: any): string {
    return DataUtils.getTitle(titleObject);
  }

  public getTranslated(object: any, key: string): string {
    return DataUtils.getTranslated(object, key);
  }

  public prev(): void {
    this._date.subtract(1, 'month');
    this._getEntity();
  }

  public next(): void {
    this._date.add(1, 'month');
    this._getEntity();
  }

  public isBooked(day: moment.Moment): boolean {
    return this.booking_offer.booking_items.some(bi => bi.item_bookings.some(b =>
      !b.cancelled &&
      moment.utc(b.date_from) < day.clone().utc().add(1, 'day') && moment(b.date_to) >= day)
    );
  }

  public isCancelled(day: moment.Moment): boolean {
    return this.booking_offer.booking_items.some(bi => bi.item_bookings.some(b =>
      b.cancelled &&
      moment.utc(b.date_from) < day.clone().utc().add(1, 'day') && moment(b.date_to) >= day)
    );
  }

  public isDisabled(day: moment.Moment): boolean {
    return this.booking_offer.booking_holidays && this.booking_offer.booking_holidays.some(h =>
      moment.utc(h.date_from) < day.clone().utc().add(1, 'day') && moment(h.date_to) >= day);
  }

}
